const Kategoriya3211 = () => {
    return (
        <div style={{ fontFamily: "Times New Roman", fontSize: "14pt" }} className="container mt-5">
    <h3 className="text-center text-primary">
        3-sinf 2-chorak<br />
        Mavzu: Gap bo'laklari<br />
        "Eng oson" bo'limidagi topshiriqlar va ularni o'tkazish metodikasi
    </h3>
    <b>1-mashq. Nuqtalar o'rniga qaysi so'zlarni qo'yish mumkin?</b><br />
    <i>Ta'limiy maqsad:</i> O'quvchilarning gap bo'laklari haqidagi ko'nikmalarini rivojlantirish.<br />
    <i>Mashg'ulot davomiyligi:</i> 3-4 daqiqa<br />
    Do'st …. gapirar, dushman … gapirar.<br />
    Suvsiz joyda hayot … .
    <p><b>2-mashq. Juftlikda ishlang. Aralash berilgan so'zlardan gaplar hosil qiling.</b></p>
    <p><i>Ta'limiy maqsad:</i> O'quvchilarning gap tuzish haqidagi ko'nikmalarini rivojlantirish.</p>
    <p><i>Mashg'ulot davomiyligi:</i> 3-4 daqiqa</p>
    <p>kun yoqqan kulib quyosh kun tanga boqqan bahor</p>
    <p>________________________________________________________________</p>
    <p>kunlari ortda qolib boshlandi kuzak shamoli qishning sovuq izg'irinli haqiqiy</p>
    <p>______________________________________________________________</p>
    <p><b>3-mashq. FDM usulidan foydalanib, berilgan fikrni izohlang.</b></p>
    <p><i>Ta'limiy maqsad:</i> O'quvchilarning bog'lanishli nutq haqidagi ko'nikmalarini rivojlantirish.</p>
    <p><i>Mashg'ulot davomiyligi:</i> 3-4 daqiqa</p>
    <p><b>Jismoniy sog'lomlik – barkamollik belgisi</b></p>
    <p>Fikr: ___________________________________________________________</p>
    <p>Dalil: _________________________________________________________</p>
    <p>Misol: ________________________________________________________</p>
        </div>
    )
}
export default Kategoriya3211;